import { Injectable } from '@angular/core';
import { Platform } from 'ionic-angular';
import { Network } from '@ionic-native/network';
import { Geolocation } from '@ionic-native/geolocation';
declare var google: any;

@Injectable()
export class GoogleMaps {

  mapElement: any;
  pleaseConnect: any;
  location: any;
  marker: any;
  map: any;
  mapInitialised = false;
  mapLoaded: any;
  mapLoadedObserver: any;
  currentMarker: any;
  apiKey = 'AIzaSyDcuvQelAX-JwmkCHbrMFGnEaIpg7mw54M';

  onDevice: boolean;

  constructor(public network: Network, public geolocation: Geolocation, public platform: Platform) {
    this.onDevice = this.platform.is('cordova');
  }

  init(mapElement: any, pleaseConnect: any, location: any, marker: any): Promise<any> {

    this.mapElement = mapElement;
    this.pleaseConnect = pleaseConnect;
    this.location = location;
    this.marker = marker;

    return this.loadGoogleMaps();

  }

  loadGoogleMaps(): Promise<any> {

    return new Promise((resolve) => {

      if (typeof google == 'undefined' || typeof google.maps == 'undefined') {

        console.log('Google maps JavaScript needs to be loaded.');
        this.disableMap();

        if (this.isOnline()) {

          console.log('Online');

          window['mapInit'] = () => {

            this.initMap().then(() => {
              resolve(true);
            });

            this.enableMap();
          }

          const script = document.createElement('script');
          script.id = 'googleMaps';

          if (this.apiKey) {
            script.src = 'https://maps.googleapis.com/maps/api/js?key=' + this.apiKey + '&callback=mapInit&libraries=places';
          } else {
            script.src = 'https://maps.googleapis.com/maps/api/js?callback=mapInit';
          }

          document.body.appendChild(script);

        }
      } else {

        console.log('No Online');

        if (this.isOnline()) {
          this.initMap();
          this.enableMap();
        }
        else {
          this.disableMap();
        }

        resolve(true);

      }

      this.addConnectivityListeners();

    });

  }

  initMap(): Promise<any> {

    this.mapInitialised = true;

    return new Promise((resolve) => {

      // this.geolocation.getCurrentPosition().then((position) => {

      // let latLng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);

      const latLng = new google.maps.LatLng(this.location.latitude, this.location.longitude);

      const mapOptions = {
        // center: latLng,
        // zoom: 15,
        // mapTypeId: google.maps.MapTypeId.ROADMAP
        center: latLng,
        zoom: 17,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        disableDefaultUI: true,
        disableDoubleClickZoom: true,
        styles: [
          {
            featureType: 'all',
            elementType: 'labels',
            stylers: [
              { visibility: 'on' }
            ]
          }
        ]
      }

      this.map = new google.maps.Map(this.mapElement, mapOptions);
      this.addMarker();
      resolve(true);

      // });

    });

  }

  disableMap(): void {

    if (this.pleaseConnect) {
      // this.pleaseConnect.style.display = "block";
    }

  }

  enableMap(): void {

    if (this.pleaseConnect) {
      // this.pleaseConnect.style.display = "none";
    }

  }

  addConnectivityListeners(): void {

    this.watchOnline().subscribe(() => {

      setTimeout(() => {

        if (typeof google == 'undefined' || typeof google.maps == 'undefined') {
          this.loadGoogleMaps();
        }
        else {
          if (!this.mapInitialised) {
            this.initMap();
          }

          this.enableMap();
        }

      }, 2000);

    });

    this.watchOffline().subscribe(() => {

      this.disableMap();

    });

  }

  /**
   * Marker
   */
  addMarker() {

    const marker = new google.maps.Marker({
      map: this.map,
      animation: google.maps.Animation.DROP,
      position: new google.maps.LatLng(this.location.latitude, this.location.longitude),
    });

    const content = '<h4>Information!</h4>';

    this.addInfoWindow(marker, content);

  }

  addInfoWindow(marker, content) {

    const infoWindow = new google.maps.InfoWindow({
      content: content
    });

    google.maps.event.addListener(marker, 'click', () => {
      infoWindow.open(this.map, marker);
    });

  }

  /**
   * Check Connection
   */
  isOnline(): boolean {
    if (this.onDevice && this.network.type) {
      return this.network.type != 'none';
    } else {
      return navigator.onLine;
    }
  }

  isOffline(): boolean {
    if (this.onDevice && this.network.type) {
      return this.network.type == 'none';
    } else {
      return !navigator.onLine;
    }
  }

  watchOnline(): any {
    return this.network.onConnect();
  }

  watchOffline(): any {
    return this.network.onDisconnect();
  }

}



// WEBPACK FOOTER //
// ./src/providers/google-maps/google-maps.ts